<template>
    <div class="mt-3 mb-3">
        <b-row>
            <b-col md="7">
                <b-card>
                    <h3 class="strong">Users</h3>
                    <b-row class="mt-4 mb-4">
                        <b-col sm="4">
                            <b-input-group>
                                <b-form-input v-model="filter" placeholder="Filter..."></b-form-input>
                                <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-table
                        striped hover outlined fixed
                        show-empty
                        :items="items"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        @filtered="onFiltered"
                    >
                        <template slot="actions" slot-scope="row">
                            <b-button class="mr-1" size="sm" variant="warning" @click="didTapResetPassword(row.item)" v-b-tooltip.hover title="Reset Password">
                                <font-awesome-icon class="fa-fw" icon="key"/>
                            </b-button>
                            <b-button size="sm" variant="danger" @click="didTapDelete(row.item)" v-b-tooltip.hover title="Delete">
                                <font-awesome-icon class="fa-fw" icon="times"/>
                            </b-button>
                        </template>
                    </b-table>
                    <b-row class="mt-2">
                        <b-col md="4">
                        <b-button variant="dark" disabled>
                            {{ totalRows }} users
                        </b-button>
                        </b-col>
                        <b-col md="8">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"></b-pagination>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col md="5">
                <b-card>
                    <h4 class="strong">New User</h4>
                    <hr />
                    <div v-if="submitStatus != ''">
                        <b-alert variant="success" :show="submitStatus == 'OK'">
                            <strong>Success!</strong> The new user has been successfully created!
                        </b-alert>
                        <b-alert variant="danger" :show="submitStatus != 'OK'">
                            <strong>Error!</strong> {{ submitStatus }}
                        </b-alert>
                    </div>
                    <b-form-text>Username</b-form-text>
                    <b-input v-model="username" />
                    <b-form-text class="mt-3">Full Name</b-form-text>
                    <b-input v-model="fullName" />
                    <b-form-text class="mt-3">Role</b-form-text>
                    <b-form-select v-model="role" :options="optRole" />
                    <b-form-text>
                        <span v-if="role == 'Power User'">Power Users are users with elevated privileges to see and edit every calculations in this system.</span>
                        <span v-else-if="role == 'Basic User'">Basic users are standard users with capabilites of creating and maintaining their own calculations.</span>
                    </b-form-text>
                    <b-alert variant="warning" class="mt-3" style="padding: 0.5rem" show>
                        <b-form-text style="margin: 0">
                            All new users are given the default password of <strong>password1234</strong>. Please advise new users to immediately change their password.
                        </b-form-text>
                    </b-alert>
                    <b-row>
                        <b-col md="12" style="text-align: end">
                            <b-btn variant="primary" @click="didTapCreate" :disabled="isSubmitting">
                                {{ isSubmitting ? "Creating..." : "Create" }}
                            </b-btn>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'user-management',
    data() {
        return {
            filter: "",
            fields: [
                { key: "username", label: "Username",  sortable: true },
                { key: "fullname", label: "Full Name", sortable: true },
                { key: "role", label: "Role" },
                { key: "actions", label: "Actions" }
            ],
            items: [],

            currentPage: 1,
            perPage: 5,
            filter: "",
            totalRows: 0,

            isSubmitting: false,
            submitStatus: "",

            // New user
            username: "",
            fullName: "",
            role: "Basic User",
            optRole: ["Basic User", "Power User"]

        }
    },
    methods: {

        onFiltered(items) {
            this.totalRows = items.length
            this.currentPage = 1
        },

        didTapCreate() {

            if(this.username == "" || this.fullName == "") {
                return
            }

            let payload = {
                username: this.username,
                fullName: this.fullName,
                role: this.role
            }

            this.isSubmitting = true
            this.$axios.post("/users", payload).then(response => {

                let res = response.data
                this.submitStatus = res.message

                if(res.message == "OK") {

                    this.username = ""
                    this.fullName = ""

                    let id = res.data.id
                    this.items.push({
                        id: id,
                        username: payload.username,
                        fullname: payload.fullName,
                        role: payload.role
                    })

                }

            })
            .catch(error => {
                this.submitStatus = "An error occurred, please wait a moment and retry!"
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

        didTapResetPassword(item) {
            
            let confirmString = `Reset ${item.fullname}'s password? The password will be reset to password1234. (without the dot)`

            if(confirm(confirmString)) {

                let payload = {
                    id: item.id
                }

                this.$axios.post("/users/resetPassword", payload).then(response => {

                    let res = response.data

                    if(res.message == "OK") {
                        this.$helper.toastSuccess(this, "Password has been reset successfully!")
                    }
                    else {
                        this.$helper.toastError(this, res.message)
                    }

                })
                .catch(error => {
                    this.$helper.toastError(this, "An error occurred, please wait a moment and retry!")
                })

            }

        },

        didTapDelete(item) {

            let confirmString = `Delete ${item.fullname}'s account? His/her calculations will still be stored.`

            if(confirm(confirmString)) {

                this.$axios.delete(`/users/${item.id}`).then(response => {

                    let res = response.data

                    if(res.message == "OK") {

                        this.$helper.toastSuccess(this, "User successfully deleted!")
                        this.items = this.items.filter(it => { return it.id != item.id })

                    }
                    else {
                        this.$helper.toastError(this, res.message)
                    }

                })
                .catch(error => {
                    this.$helper.toastError(this, "An error occurred, please wait a moment and retry!")
                })
            }

        }

    },
    created: function() {
        // Fetch calculations
        this.$axios.get('/users').then(response => {

            let res = response.data
            if(res.message == "OK") {
                this.items = res.data.users
                this.totalRows = this.items.length
            }
            else if(res.message == "UNAUTHORIZED") {
                this.$router.replace("/dashboard")
            }
            else {
                this.$helper.toastError(this, 'Failed to retrieve users.')
            }

        }).catch(() => {
            this.$helper.toastError(this, 'Failed to retrieve users.')
        })
    }
}
</script>